var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var textTracer = require("./fonts/textTracer.js");
var PosAngleData = require("../abstract/posAngleData.js");
var TextData = require("./textData.js");
var units_enum = ["", "μm", "mm", "in", "mil", "pt"];
var PropertyToMesh = require("./../threejsExport/propertyToMesh.js");

var PropertyData = function (textData) {
    var self = this;
    this.makeObservableTreeNode();

    this.textData = this.value("text", true);

    if(textData) this.textData(textData);

    var addShadows = function () {
        if(self.textData()) {
            // TODO can i loop through shadows?
            self.geometry = self.textData().geometry;
            self.segmentedGeometry = self.textData().segmentedGeometry;
            self.boundingBox = self.textData().boundingBox;// not entirely correct, since it doesn't include the '<' char...
            // dont use mesh!
            self.text = self.textData().text;
            self.strokeWidth = self.textData().strokeWidth;
            self.fontSize = self.textData().fontSize;
            self.font = self.textData().font;
            self.fontUnit = self.textData().fontUnit;
            self.color = self.textData().color;     // if color == null, color is inherited from layer to which this text is added.
            self.anchor = self.textData().anchor; // start, middle, end
            self.alignment = self.textData().alignment; // baseline, central, hanging
            self.keepReadable = self.textData().keepReadable;
            self.offset = self.textData().offset;
            // im what they call a 'real tight wrapper'
        }
    };

    if(this.textData()) addShadows();
    this.textData.onChange("textChanged", addShadows);

    PropertyToMesh.call(this);
};

lib_core.mixin(PropertyData, lib_core.ObservableTreeNode);
lib_core.mixin(PropertyData, PosAngleData);

module.exports = PropertyData;

lib_core.JsonParser.registerClass(PropertyData, "PropertyData");

PropertyData.prototype.move = function (vec) {
    return this.textData() && this.textData().move(vec);
};

PropertyData.prototype.rawBB = function () {
    if(this.textData()){
        return this.textData().rawBB();
    } else {
        return null;
    }
};

PropertyData.prototype.rotate = function (angle) {
    return this.textData() && this.textData().rotate(angle);
};

PropertyData.prototype.flip = function (flipline) {
    return this.textData() && this.textData().flip(flipline);
};

PropertyData.prototype.getPos = function() {
    return this.textData().pos();
}
